<template>
  <div>
    <div class="ml-md-3 searchCond-wrapper">
      <div>
        <label
          class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0 mr-md-3"
        >
          所在地
        </label>
        <div class="d-md-inline text-left">
          <select
            class="d-inline form-control col-4 col-md-3 ml-md-2"
            v-model="searchCond.TODO_CD"
            @change="changePref"
          >
            <option
              v-for="pref in prefList"
              :value="pref.value"
              :key="pref.value"
            >
              {{ pref.text }}
            </option>
          </select>
          <select
            class="d-inline form-control col-7 col-md-4 ml-2"
            v-model="searchCond.SHIKU_CD"
            :disabled="!cityList.length"
            @change="changeCity"
          >
            <option :value="null">未選択</option>
            <option
              v-for="city in cityList"
              :value="city.value"
              :key="city.value"
            >
              {{ city.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-md-2">
        <label class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0">
          絞り込み
        </label>
        <input
          type="text"
          class="d-inline form-control col-12 col-md-8 ml-md-2"
          v-model="searchCond.NAME"
          placeholder="店舗・ヤード・港名で検索ください"
          @change="search"
        />
      </div>
    </div>
    <div class="ml-2 ml-md-4">
      <p v-if="!isLoading" class="mt-2 ml-4 kome red">
        オークション会場は「直接指定」からご指定ください
      </p>
    </div>

    <div class="mt-4 mt-md-3 ml-md-3 mx-auto">
      <label class="d-inline col-3 col-md-2 col-lg-2 px-0">選択：</label>
      <span v-if="isMobile" class="bold blue col-8 col-md-9 px-0">
        {{ !selectedItem ? '選択なし' : _omitText(selectedItem.NAME, 22) }}
      </span>
      <span v-else class="bold blue col-8 col-md-9 px-0">
        {{ !selectedItem ? '選択なし' : omitText(selectedItem.NAME, 28) }}
      </span>
    </div>
    <div v-if="isError" class="err-message ml-md-3 mx-auto mb-md-2 border-red">
      <p>選択必須です。</p>
    </div>

    <section id="order-master-hikino">
      <div v-if="isLoading" class="spinner my-5">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <md-table
          v-if="recordList.length"
          v-model="recordList"
          md-card
          md-fixed-header
          :class="[
            'bg-gray mx-0 mx-md-3 p-1 black-svg checkbox',
            { 'h-250': isDialog },
          ]"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click="selected(item)"
            :class="{ selected: item.ID === selectedItemId }"
          >
            <md-table-cell v-if="!isMobile" md-label="">
              <input type="radio" :value="item.ID" v-model="selectedItemId" />
            </md-table-cell>
            <md-table-cell md-label="場所名" md-sort-by="NAME">
              <span v-if="!isMobile"><span v-if="item.SPECIAL_RATE_FLG" class="special-rate">特別料金</span>{{ omitText(item.NAME, 20) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">場所名</p>
                <p class="col-9 p-0"><span v-if="item.SPECIAL_RATE_FLG" class="special-rate">特別料金</span>{{ _omitText(item.NAME, 18) }}</p>
              </div>
            </md-table-cell>
            <md-table-cell md-label="住所" md-sort-by="ADDRESS">
              <span v-if="!isMobile">{{ omitText(item.ADDRESS, 20) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">住所</p>
                <p class="col-9 p-0">{{ _omitText(item.ADDRESS, 18) }}</p>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center my-5 bold">該当データがありません。</div>
      </div>
    </section>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import _ from 'lodash'
import Mixin from '../mixin/Mixin'

const DATA_KBN = 'MASTER'
export default {
  name: 'Master',

  props: {
    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },

    /** Dialog内に表示するか */
    isDialog: {
      type: Boolean,
      default: false,
    },

    /** 画面表示フラグ */
    isActive: {
      type: Boolean,
      default: false,
    },

    /** 特別料金が存在するかフラグ */
    isSpacialRate: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [Mixin],
  data: () => ({
    /** バリデーションを実行したことがあるかフラグ */
    isValided: false,

    /** ローディングフラグ */
    isLoading: false,

    /** 市区町村リスト */
    cityList: [],

    /** 検索条件 */
    searchCond: {
      TODO_CD: null,
      SHIKU_CD: '',
      NAME: null,
    },

    /** 登録済みテーブル一覧 */
    recordList: [],

    /** 選択データ*/
    selectedItem: null,

    /** 選択データID */
    selectedItemId: null,

    /** 画面を1度でも表示したか */
    isActivated: false,
  }),

  methods: {
    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.searchCond.TODO_CD) return
      Store.dispatch('address/getCityList', this.searchCond.TODO_CD).then(
        () => {
          const cityList = _.cloneDeep(Store.state.address.cityList)
          cityList.unshift({
            value: '',
            text: '未選択',
          })
          this.cityList = cityList
        }
      )
    },

    /**
     * 登録済み引取先選択
     * @param  {Object} item 選択した登録済み
     */
    selected(item) {
      this.selectedItem = item
      this.selectedItemId = item.ID
      const data = {
        FAVORITE_ID: null,
        AA_KAISAI_BI: null,
        AA_CD: null,
        AA_ID: null,
        TOROKUBAYO_KO_ID: item.ID,
        YUBIN1: item.YUBIN_BANGO1,
        YUBIN2: item.YUBIN_BANGO2,
        TODO_CD: item.TODO_CD,
        TODO_MEI: item.TODO_MEI,
        SHIKU_CD: item.SHIKU_CD,
        SHIKU_MEI: item.SHIKU_MEI,
        BANCHI: item.BANCHI,
        MEI: item.NAME,
        TEL: item.HCB_TEL || item.TEL,
        YUSO_KBN: this.convYusoKbnFromHcb(item.HCB_ZOKUSEI_CD),
        HCB_ZOKUSEI_CD: item.HCB_ZOKUSEI_CD,
        LANDMARK_KBN: item.LANDMARK_KBN,
        TANTO_MEI: item.TANTO_SYA,
        TANTO_TEL: null,
        TEIKYU_BI: item.TEIKYU_BI,
        EIGYO_KAISI_JIKAN: null,
        EIGYO_SYURYO_JIKAN: null,
        HANNYUSYUTU_JIKAN: item.HANNYU_JIKAN,
      }
      this.$emit('setData', data, DATA_KBN)
    },

    /** 入力データを初期化する */
    reset() {
      this.selectedItem = null
      this.selectedItemId = null
      this.$emit('reset', DATA_KBN)
    },

    /** 検索する */
    search() {
      this.isLoading = true
      this.reset()
      return this.getTransports({ cond: this.searchCond }).then((list) => {
        this.recordList = list
        this.isLoading = false
        if (!this.searchCond.NAME && !this.searchCond.SHIKU_CD && !this.searchCond.TODO_CD) {
          // 検索条件がない場合（全件取得の場合）に特別料金が存在するかチェック
          this.$emit('update:isSpecialRate', Boolean(list.find((item) => item.SPECIAL_RATE_FLG)))
        }
      })
    },

    /** 都道府県変更 */
    changePref() {
      this.cityList = []
      this.searchCond.SHIKU_CD = ''
      this.search()
      this.getCityList()
    },

    /** 市区町村変更 */
    changeCity() {
      this.search()
    },

    /** 入力状況を再現する */
    async revival() {
      const cond = this._searchCond
      this.searchCond.TODO_CD = cond.TODO_CD
      this.searchCond.SHIKU_CD = cond.SHIKU_CD
      this.getCityList()
      await this.search()
      const item = this.recordList.filter((v) => v.ID == cond.ID)[0]
      if (item) this.selected(item)
    },
  },

  computed: {
    /** 入力エラーがあるか判定 */
    isError() {
      return this.isValided && !this.selectedItem
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading(val) {
      this.$emit('loaded', val, DATA_KBN)
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond) this.revival()
        else await this.search()
        this.$emit('searched', DATA_KBN)
      }
    },

    /** バリデーション実行フラグ */
    isValid(val) {
      if (val) {
        this.isValided = true
        this.$emit('setInvalid', this.isError, DATA_KBN)
      }
    },

    /** 画面表示フラグ監視 */
    isActive(val) {
      if (val && !this.isActivated) {
        this.search()
        this.isActivated = true
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.selected
  background: $baseBlueColor
  color: #fff
.bottom-1
  margin-bottom: 1rem
.yusosaki-mei
  height: 56px
.special-rate
  font-size: 10px;
  background: red;
  color: white;
  padding: 2px;
  font-weight: bold;
</style>



// WEBPACK FOOTER //
// src/components/order/Master.vue